<template>
  <p-icon class="animate-spin"
          icon-name="spinner"
          size="large" color="blue"/>
</template>
